import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes }  from 'react-router-dom';

import Header from '../header/Header';
import Spinner from '../header/Header';
import '../../style/style.scss';
// DYNAMIC IMPORTS SHOULD GO AFTER STATIC IMPORTS!!!!!!!
const Page404 = lazy(() => import('../pages/404'));
const CharactersPage = lazy(() => import('../pages/CharactersPage'));
const ComicsPage = lazy(() => import('../pages/ComicsPage'));
const ComicItem = lazy(() => import('../pages/ComicItem'));

const App = () => {
    
        return (
            <Router>
                <div className="container">
                <Header/>
                    <Suspense fallback={<Spinner/>}>
                    <Routes>
                        <Route path='/' element={<CharactersPage/>}/>
                        <Route path='/comics' element={<ComicsPage/>}/>
                        <Route path='/comics/:comicId' element={<ComicItem/>}/>
                        {/* <Route path={`/comics/${/\D+/}`} element={<Page404/>}/> */}
                        <Route path='*' element={<Page404/>}/>
                    </Routes>
                    </Suspense>
                </div>
            </Router>
            
        )
    };

export default App;
